<dx-popup
    [showTitle]="true"
    title="Settings"
    [dragEnabled]="false"
    [hideOnOutsideClick]="true"
    [showCloseButton]="false"
    [visible]="visible"
    [toolbarItems]="toolbarItems"
    [maxWidth]="500"
    [height]="'auto'"
>   
    <dx-form 
        [formData]="formData"
        >
        <dxi-item
            dataField="machineName"
            editorType="dxSelectBox"
            [isRequired]="true"
            [editorOptions]="{
                dataSource: selectOptions,
                displayExpr: 'name',
                valueExpr: 'name',
                placeholder: 'Select machine'
            }">
        </dxi-item>
    </dx-form>
</dx-popup>